module.exports = __webpack_public_path__ + "static/media/close_not.8d4c9603.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_not.svg
// module id = 405
// module chunks = 3